import React from "react";
import { motion } from "framer-motion";
import Particles from "react-tsparticles";
import { Engine } from "tsparticles-engine";
import { loadSlim } from "tsparticles-slim"; // ✅ جایگزین جدید loadFull
import "./AboutUs.css";
import logo from '../karuncup.svg';
import { Link } from "react-router-dom";
const AboutUs = () => {
  const particlesInit = async (engine: Engine) => {
    await loadSlim(engine); // ✅ نسخه سبک و سازگار
  };

  return (
    <div className="about-page">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          background: { color: "#000000" },
          fpsLimit: 60,
          particles: {
            number: { value: 70 },
            color: { value: "#80dd34" },
            links: {
              enable: true,
              color: "#80dd34",
              distance: 150,
              opacity: 0.3,
              width: 1,
            },
            move: {
              enable: true,
              speed: 1.2,
              outModes: { default: "out" },
            },
            opacity: { value: 0.6 },
            size: { value: { min: 1, max: 4 } },
          },
          interactivity: {
            events: { onHover: { enable: true, mode: "repulse" } },
            modes: { repulse: { distance: 100 } },
          },
        }}
      />

      <div className="about-content">
          <div className="flex items-center justify-between">
            
                    <motion.img
          src={logo}
          alt="Karun Cup Logo"
          className="about-logo"
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1 }}
        />
        <div className="text-center mt-8">
                      <Link
                        to="/"
                        className="inline-block bg-lime-500 text-black font-semibold px-6 py-3 rounded-xl hover:bg-lime-400 transition"
                      >
                        بازگشت به صفحه‌ی نخست
                      </Link>
                    </div>
          </div>
        

        <motion.h1
          className="about-title"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          درباره جشنواره کارون‌کاپ
        </motion.h1>

              <motion.p
          className="about-intro text-right"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          جشنواره و مسابقات فناوری‌های نوین در صنعت آب و برق (کارون‌کاپ) با هدف
          شناسایی نخبگان، توسعه فناوری‌های بومی و تقویت ارتباط میان سازمان آب و
          برق خوزستان، دانشگاه‌ها و شرکت‌های تخصصی از سال ۱۳۹۵ آغاز شد.
        </motion.p>

        <motion.div
          className="about-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h2>تاریخچه و دستاوردها</h2>
          <p className="text-right">
            سه دوره نخست این جشنواره در سال‌های ۱۳۹۵، ۱۳۹۶ و ۱۳۹۷ برگزار شد و
            بیش از ۳۰۰۰ نخبه از ۲۱ استان کشور در قالب تیم‌های پژوهشی و فناورانه
            در آن شرکت کردند. نتایج این رویداد منجر به انعقاد قراردادهای پژوهشی،
            همکاری با شرکت‌های دانش‌بنیان و معرفی فناوری‌های کاربردی در صنعت آب
            و برق کشور گردید.
          </p>
        </motion.div>

        <motion.div
          className="about-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <h2>محورهای اصلی</h2>
          <ul className="text-right">
            <li>💡 ایده و اختراعات – جذب طرح‌های نوآورانه برای صنعت آب و برق</li>
            <li>⚙️ چالش‌های فناورانه – رقابت‌های تخصصی برای حل مسائل واقعی</li>
            <li>🤖 مسابقات رباتیک دانش‌آموزی – ترویج فرهنگ فناوری در نسل جوان</li>
          </ul>
        </motion.div>

        <motion.div
          className="about-highlight"
          initial={{ scale: 0.9, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <h2>کارون‌کاپ ۱۴۰۴</h2>
          <p className="text-right">
            چهارمین دوره این جشنواره، پس از وقفه‌ای چندساله به‌دلیل کرونا، با
            رویکردی تخصصی‌تر برگزار خواهد شد. بیش از ۷۰ جلسه کارشناسی برای
            استخراج نیازهای فناورانه سازمان آب و برق خوزستان برگزار شده تا مسیر
            جشنواره به سمت حل مسائل واقعی صنعت هدایت شود.
          </p>
        </motion.div>

        <motion.div
          className="about-quote"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1.2 }}
        >
          <p className="text-right">
            <span>کارون‌کاپ</span>، نماد هم‌افزایی علم، صنعت و خلاقیت؛ حرکتی
            ماندگار برای پرورش نسلی پژوهشگر و اثرگذار در آینده صنعت آب و برق
            ایران.
          </p>
        </motion.div>

        <footer className="about-footer">
          © 1405 Karun Cup | جشنواره فناوری‌های نوین صنعت آب و برق
        </footer>
      </div>
    </div>
  );
};
export default AboutUs;
